import moment from 'moment';
import settings from '../settings';

import FacebookPostCalculator from '../model/facebook-post-calculator';
import LinkedInPostCalculator from '../model/linkedin-post-calculator';
import TwitterPostCalculator from '../model/twitter-post-calculator';
import InstagramPostCalculator from '../model/instagram-post-calculator.js';

import Preview from './preview';
import ShareBox from './sharebox';

import 'jquery-form';
import sweetalert from 'sweetalert';
import nunjucks from 'nunjucks'; // TODO: Remove due to being unused?
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();

import { debounce as _debounce } from 'lodash';
import normalizeUrl from '../vendor/normalise-url';
import validUrl from 'valid-url';
import url from 'url';
import Post from './post';

// Define the normalize options (as defaults are ... crazy)
let normalizeOptions = {
    defaultProtocol: 'https:',
    normalizeProtocol: false,
    stripAuthentication: true,
    stripWWW: false,
    removeQueryParameters: false,
    removeTrailingSlash: false,
    sortQueryParameters: false,
};

export default class PostBox {
    calculators;
    $elem;

    constructor($elem, liveposts, postInstance) {
        this.$elem = $elem;
        this.liveposts = liveposts;
        this.postInstance = postInstance;
        this.$textbox = $elem.find('.form__field--post');

        this.blur__textarea = this.blur__textarea.bind(this);
        this.focus__textarea = this.focus__textarea.bind(this);
        this.keyup__textarea = this.keyup__textarea.bind(this);
        this.click__change_preview_image = this.click__change_preview_image.bind(
            this
        );
        this.click__meta_item = this.click__meta_item.bind(this);
        this.click__postbox__post = this.click__postbox__post.bind(this);
        this.click__video_select = this.click__video_select.bind(this);
        this.submit__post_image_upload = this.submit__post_image_upload.bind(this);
        this.submit__preview_image_upload = this.submit__preview_image_upload.bind(
            this
        );
        this.change__amp = this.change__amp.bind(this);
        this.change__embargo_time = this.change__embargo_time.bind(this);
        this.submit__post = this.submit__post.bind(this);
        this.keyup__preview = this.keyup__preview.bind(this);
        this.click__undo_preview = this.click__undo_preview.bind(this);

        // Make preview title and description editable
        this.$elem.find('.article-preview__title').attr('contentEditable', true);
        this.$elem
            .find('.article-preview__description')
            .attr('contentEditable', true);

        this.previewHasBeenModified = false;

        this.processing = {};

        if (!!this.$elem.length) {
            this.calculators = {
                facebook: new FacebookPostCalculator(),
                linkedin: new LinkedInPostCalculator(),
                twitter: new TwitterPostCalculator(),
                instagram: new InstagramPostCalculator(),
            };
            this.calculatorsNew = {
                facebook: new FacebookPostCalculator(),
                linkedin: new LinkedInPostCalculator(),
                twitter: new TwitterPostCalculator(),
                instagram: new InstagramPostCalculator(),
            };
            

            this.init();
        }

        this.set_defaults();
    }

    init() {
        // var $counts = this.$elem.find('.postbox__counts__count');

        // for (var i = $counts.length - 1; i >= 0; i--) {
            
        //     var $count = $($counts[i]),
        //         calculator = $count.data('calculator'),
        //         calc;
        //     var targetClass = "";
        //     var globalThis = this.$elem;
        //     if ($count.data("share")) {
                
        //     } else {
        //         targetClass = ".form__field--post";
        //     }
        //     if (!!this.calculators[calculator]) {
        //         calc = this.calculators[calculator];

        //         calc.$counter = $count;
        //         calc.$target = this.$elem.find('.form__field--post');

                
        //         this.$elem.on('keyup', '.form__field--post', function(){
        //             if ($count.data("share")) {} else {
        //                 var te = globalThis.find(".form__field--post").val();
        //                 globalThis.find(".form__field--post--share").val(te);
        //                 calc.calculate();
        //                 for (var k = globalThis.find(".postbox__counts__count"), j = k.length - 1; j >= 0; j--) {
        //                     var vl = k[j].innerText;
        //                     var newAttr = globalThis.find(".data-share-counter--" + globalThis.find(k[j]).data("calculator") + "");
        //                     if (newAttr.length > 0) {
        //                         newAttr[0].innerText = vl;
        //                     }
    
        //                 }
        //             }
        //         });
        //         this.$elem.on('focus', '.form__field--post', calc.calculate);
        //     }
            
        // }
        var $counts = this.$elem.find('.postbox__counts__count');
        var globalThis = this.$elem;
        for (var i = $counts.length - 1; i >= 0; i--) {
            var $count =$($counts[i]),
                calculator = $count.data('calculator'),
                calc;
            if (!!this.calculators[calculator]) {
                calc = this.calculators[calculator];
                calc.$counter = $count;
                calc.$target = this.$elem.find('#postbox__post');
                this.$elem.on("keyup", "#postbox__post", calc.calculate);
                this.$elem.on("focus", "#postbox__post", calc.calculate);
                this.$elem.on("change keyup paste inputchange propertychange focus blur", "#postbox__post", function(){
                    var te = globalThis.find(".form__field--post").val();
                    globalThis.find(".form__field--post--share").val(te);
                })
            }
        }

        var $countsNew = this.$elem.find('.postbox__counts__count--share');
        for (var i = $countsNew.length - 1; i >= 0; i--) {
            var $countNew =$($countsNew[i]),
                calculator = $countNew.data('calculator'),
                textBoxId = $countNew.data('textbox-id'),
                calc;
            if (!!this.calculatorsNew[calculator]) {
                calc = this.calculatorsNew[calculator];
                calc.$counter = $countNew;
                calc.$target = this.$elem.find(textBoxId);
                this.$elem.on("keyup", this.$elem.find(textBoxId), calc.calculate);
                this.$elem.on("focus", this.$elem.find(textBoxId), calc.calculate);
            }
        }

        function getAllTags(){
            var tags = [];
            var allTagsString = $("#post-tags-db").attr("data-value").split("||,||");
            $.each(allTagsString, function(ind,val){
                var tagData = val.split("|,|");
                if(tagData[0]){
                    tags.push({"id":tagData[0], "title": tagData[1], "color": tagData[2]});
                }
            })
            return tags;
        }

        var $select = $('.postbox__tags__field').selectize({
            maxItems: null,
            valueField: 'id',
            labelField: 'title',
            searchField: 'title',
            plugins: ["remove_button"],
            options: getAllTags(),
            create: false,
            onItemAdd: function(data, options){
                var alltags = getAllTags();
                var selectedOne = alltags.find(o => o.id === data);
                if(selectedOne.color){
                    if(selectedOne.color==="#000000"){
                        options.attr("style","background-color:"+selectedOne.color+";color:#fff");
                    }else{
                        options.attr("style","background-color:"+selectedOne.color);
                    }
                    
                }
            }
        });

        if($("#seleced-post-tags-db").length > 0){
            var tags = $("#seleced-post-tags-db").attr("data-value").split(",");
            var selectedTags = [];
            $.each(tags, function (e, i) {
                var tagI = getAllTags().find(function (t) {
                    return t.title === i.trim();
                });
                if(tagI && tagI.id){
                    selectedTags.push(tagI.id);
                }
            });
            var selectize = $select[0].selectize;
            selectize.setValue(selectedTags);
        }

        this.$elem
            .on('click', '.postbox__post', this.click__postbox__post)
            .on('click', '#article-preview-clear-button', this.click__undo_preview)
            .on('blur', '.form__field--post', this.blur__textarea)
            .on('keyup', '.form__field--post', this.keyup__textarea)
            .on('focus', '.form__field--post', this.focus__textarea)
            .on('focus', '.postbox__meta input', this.click__meta_item)
            .on(
                'click',
                '.postbox__meta__section label, postbox__meta__section a',
                this.click__meta_item
            )
            .on('click', '.js-image-upload', this.click__image_upload)
            .on('click', '.postbox__documents--toggle', this.click__documents_toggle)
            .on(
                'click',
                '.postbox__documents--selector--document--select',
                this.click__document_select
            )
            .on(
                'click',
                '.postbox-attached__remove--document--remove-icon',
                this.click__document_remove
            )

            .on('click', '.postbox__video--toggle', this.click__video_toggle)

            .on(
                'click',
                '.postbox__video--selector--video--select',
                this.click__video_select
            )
            .on('click', '.media__img-wrapper', this.click__change_preview_image)
            .on('click', '.postbox-attached__remove', this.click__image_remove)
            .on(
                'change',
                '.embargo-date-select',
                this.change__embargo_time.bind(this)
            )
            .on(
                'change',
                '.embargo-time-select--hour',
                this.change__embargo_time.bind(this)
            )
            .on(
                'change',
                '.embargo-time-select--minute',
                this.change__embargo_time.bind(this)
            )
            .on(
                'change',
                '.embargo-time-select--ampm',
                this.change__embargo_time.bind(this)
            )
            .on('click', '.postbox-attached__remove--video', this.click__video_remove)
            .on(
                'change',
                'input#post-image-upload[type="file"]',
                this.change__post_image
            )
            .on(
                'change',
                'input#preview-image-upload[type="file"]',
                this.change__preview_image
            )
            .on('submit', '#post-image-upload-form', this.submit__post_image_upload)
            .on(
                'submit',
                '#preview-image-upload-form',
                this.submit__preview_image_upload
            )
            .on('change', '.postbox__amp', this.change__amp)
            .on('submit', '.postbox__form', this.submit__post)
            .on('keyup', '.article-preview__title', this.keyup__preview)
            .on('keyup', '.article-preview__description', this.keyup__preview);

        if (this.$textbox.data('autopost-url') != '') {
            this.$textbox.focus();
            this.$textbox.val(
                this.$textbox.data('autopost-title') +
                ' ' +
                this.$textbox.data('autopost-url')
            );
            this.$textbox.blur();
        }

        if (this.$elem.hasClass('is-editing')) {
            this.$elem.addClass('is-active'); // Add the class via JS, as the styles have loaded and we won't get an ugly flash!

            var $elem = this.$elem,
                $img = $elem.find('[name="image"]'),
                $preview = $elem.find('.postbox__preview');

            if (!!!$img.val()) {
                let title = $elem.data('preview-title'),
                    url = $elem.data('preview-url'),
                    description = $elem.data('preview-description'),
                    image = $elem.data('preview-image');

                if (title.length > 0 || image.length > 0 || description.length > 0) {
                    var preview = new Preview();
                    preview.create($preview, url, title, description, image);
                } else {
                    this.regenerate_preview($preview, $elem);
                }
            }
        }
    }

    blur__textarea(ev) {
        var $elem = this.$elem,
            $preview = $elem.find('.postbox__preview'),
            $images = $elem.find('[name="images[]"]');

        if ($images.length === 0) {
            if (!this.$elem.hasClass('is-blurring')) {
                if (!!!this.$textbox.val()) {
                    this.$elem.addClass('is-blurring');

                    window.setTimeout(function() {
                        // TODO: Pointless?
                        if ($elem.hasClass('is-blurring')) {
                            // $elem.removeClass('is-active is-blurring');
                            // $elem.find('.postbox__footer').slideUp('fast');
                        }
                    }, 250);
                }
            }

            this.regenerate_preview($preview, $elem);
        }

        // Handle link shortening
        this.handleLinkShortening($elem);
    }

    click__change_preview_image(ev) {
        ev.preventDefault();

        $('#preview-image-upload').click();
    }

    regenerate_preview($preview, $elem) {
        // If the preview has already been modified, don't look it up again
        if (this.previewHasBeenModified) {
            return;
        }

        const links = this.getPostLinks(this.$textbox.val());
        var preview = new Preview();
        preview.generate_preview(links, $elem, $preview);
    }

    keyup__textarea(ev) {
        // 8: backspace
        // 46: dot
        // 32: space - potential new link
        function getLastWord(words) {

            var n = words.split("@");
            if(words.length == n[n.length - 1].length){
                return n[n.length - 1];
            }
            var o = n[n.length - 1].split(" ");
            if(o.length < 8){
                return "@"+n[n.length - 1];
            }
            return "";
        
        }
        if(ev.keyCode){
            var lastWord = getLastWord(ev.target.value);
            if($("#iconLinkedin:checked").length > 0 && lastWord.indexOf("@") > -1 && lastWord.length > 3){
                this.linkedinMentions(ev, lastWord);
            }
        }
        if (ev.keyCode === 8 || ev.keyCode === 46 || ev.keyCode === 32) {
            let $elem = this.$elem;
            let $img = $elem.find('[name="image"]');
            let $preview = $elem.find('.postbox__preview');

            if (!$img.val()) {
                this.regenerate_preview($preview, $elem);
            }

            if (ev.keyCode == 32) {
                // Handle link shortening
                this.handleLinkShortening($elem);
            }
        }
    }

    linkedinMentions(e, lastWord){
        var textLength = ($("#postbox__post").val().length > 83) ?($("#postbox__post").val().length / 83) : $("#postbox__post").val().length;

        var i = e.target.getBoundingClientRect(),
        a = textLength * 8,
        s = i.top;
    
        $("#linkedin-mentioned").html("");
        $.ajax({ 
            url: "/linkedin-mentioned?keyword="+lastWord.replace("@",''), 
            method: "GET",
            dataType: 'JSON',
            success: function (data) {
                var html = "<ul>";
                $.each(data, (index,val) => {
                    html+= '<li data-urn="'+val.urn+'">'+((val.logoUrl) ? '<image src="'+val.logoUrl+'"/>': "<i class='fa fa-linkedin'/>") +'<a href="javascript:;">' + val.name + '</a> </li>';
                });
                html+= "</ul>";
                $("#linkedin-mentioned").html(html);
                afterResponse(a,s, data);
            },
            error: function (data) {
                console.log("error");
                console.log(data);
            }
        });
        function afterResponse(a,s, data){
            $("#linkedin-mentioned").css("left", a);
            $("#linkedin-mentioned").css("top", s);
            if(data.length > 0){
                $("#linkedin-mentioned").show();
            }else{
                $("#linkedin-mentioned").hide();
            }
            
            $("#linkedin-mentioned").find("ul").find("li").off().on("click", function () {
                var val = $("#postbox__post").val();
                var result = val.replace(lastWord, "@["+$(this).text().trim()+"]("+$(this).attr("data-urn")+")");
                $("#postbox__post").val(result);
                $("#linkedin-mentioned").hide();
            }),
            $("body").on("click", function () {
                $("#linkedin-mentioned").hide();
            });
        }
    }

    change__amp(ev) {
        var $elem = this.$elem,
            $button = $elem.find('.postbox__post-share'),
            $amp_switch = $(ev.target),
            key = $amp_switch.val() == 1 ? 'amped-' : 'unamped-';

        if ($amp_switch.val() == 1) {
            $button.removeAttr('disabled');
        } else {
            $button.attr('disabled', 'disabled');
        }
    }

    change__post_image(ev) {
        $('#post-image-upload-form').submit();
    }

    change__preview_image(ev) {
        $('#preview-image-upload-form').submit();
    }

    click__image_remove(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_parent = $(ev.delegateTarget),
            $my_img = $me.find('img'),
            $type = $my_img.data('type'),
            short_url_id = $my_img.data('upload-id'),
            my_img = $my_img.prop('src'),
            $images = $my_parent.find('.postbox__images');

        $my_parent
            .find('input[name="short_urls[]"]')
            .filter('[value="' + short_url_id + '"]')
            .remove();
        if($type == "video"){
            $("#postbox_video_id").val("remove-video");
        }else{
            $images
            .find('[value="' + my_img + '"]')
            .filter('input')
            .remove();
        }
        

        var $attached = $my_parent.find('.postbox-attached'),
            $image_list = $attached.find('.postbox-attached__list'),
            $image_items = $image_list.find('.postbox-attached__list__item');

        $me.closest('.postbox-attached__list__item').remove();

        if ($image_items.length == 0) {
            $my_parent.find('.postbox-attached').addClass('is-hidden');
        }

        // if ID attribute, ping off a delete request too
        if ($my_img.attr('data-id')) {
            $.ajax({
                url: '/posts/' + $my_img.data('post-id') + '/images/' + $my_img.data('id'),
                method: 'DELETE',
            });
        }
    }

    
    click__video_remove(ev) {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_parent = $(ev.delegateTarget);
        var $attached = $my_parent.find('.postbox-attached'),
            $image_list = $attached.find('.postbox-attached__list'),
            $image_items = $image_list.find('.postbox-attached__list__item');

        $me.closest('.postbox-attached__list__item').remove();
        $('#postbox_video_id').val('');

        if ($image_items.length == 0) {
            $my_parent.find('.postbox-attached').addClass('is-hidden');
        }
    }

    click__documents_toggle(ev){
        ev.preventDefault();
        if ($('.postbox__documents--selector').is(':visible')) {
            $('.postbox__documents--selector').hide();
        } else {
            $('.postbox__video--selector').hide();
            $('.postbox__documents--selector').hide();
            var $me = $(ev.currentTarget),
                request;
                // Run the request
                request = $.ajax({
                    headers: settings.api_headers,
                    url: $me.attr('href'),
                    type: 'get',
                    dataType: 'json',
                }).always((d, ts, jq) => {
                    if (jq.status == 200) {

                        var html = nunjucksEnv.render('html/post/documents-selector.html', {
                            documents: d.model.media,
                        });
                        
                        $('.postbox__documents--selector--wrapper').html(html);
                    }
                });
                $('.postbox__documents--selector').removeClass('hide').show();
        }
    }

    click__video_toggle(ev) {
        ev.preventDefault();

        if ($('.postbox__video--selector').is(':visible')) {
            $('.postbox__video--selector').hide();
        } else {
            $('.postbox__video--selector').hide();
            $('.postbox__documents--selector').hide();
            var $me = $(ev.currentTarget),
                request;
            // Run the request
            request = $.ajax({
                headers: settings.api_headers,
                url: $me.attr('href'),
                type: 'get',
                dataType: 'json',
            }).always((d, ts, jq) => {
                if (jq.status == 200) {
                    var html = nunjucksEnv.render('html/post/video-selector.html', {
                        videos: d.model.media,
                    });
                    $('.postbox__video--selector--wrapper').html(html);
                }
            });
            $('.postbox__video--selector').removeClass('hide').show();
        }
    }
    click__document_remove(ev){
        ev.preventDefault()
        $('.postbox-attached__list__item--document').remove();
        $("#postbox_documents_id").val("");
    }
    click__document_select(ev){
        let $me = $(ev.target),
            $textbox = this.$textbox,
            $image_list = $('.postbox-attached__list'),
            $image_list_container = $('.postbox-attached'),
            // This will become the preview'd image
            $image_item = $(
                nunjucksEnv.render('html/ui/document-item.html', {
                    url: $me.data('document-path'),
                    id: $me.data('document-id'),
                    name: $me.data('document-name'),
                    thumbnail: $me.data('document-thumbnail'),
                })
            ),
        $preview = $image_item.find('.postbox-attached__image');
        if($("#normal-thumbnail-preview .preview_items").length > 0){
            alert("Images already selected for this Post. You can only add image or document into a post. ");
            return false;
        }
        if($(".postbox-attached__list__item--video").length > 0){
            alert("Video already selected for this Post. You can only add image or document or video into a post. ");
            return false;
        }
        $('.postbox-attached__list__item--document').remove();
        $image_list.append($image_item);
        $image_list_container.removeClass('is-hidden');
        
        // prevent flash of bigger size
        $preview
            .prop('src', $me.data('document-path'))
            .data('upload-id', $me.data('document-id'));
        $image_list.removeClass('is-hidden');
        
        $('#postbox_documents_id').val($me.data('document-id'));
        //this.$textbox.focus();
        $('.postbox__documents--selector').hide();
        return false;
    }

    click__video_select(ev) {
        let $me = $(ev.target),
            $textbox = this.$textbox,
            $image_list = $('.postbox-attached__list'),
            $image_list_container = $('.postbox-attached'),
            // This will become the preview'd image
            $image_item = $(
                nunjucksEnv.render('html/ui/video-item.html', {
                    url: $me.data('video-thumbnail'),
                    id: $me.data('video-id'),
                })
            ),
            $preview = $image_item.find('.postbox-attached__image');
        if($("#normal-thumbnail-preview .preview_items").length > 0){
            alert("Images already selected for this Post. You can only add image or document or video into a post. ");
            return false;
        }
        if($(".postbox-attached__list__item--document").length > 0){
            alert("Document already selected for this Post. You can only add image or document or video into a post. ");
            return false;
        }
        $('.postbox-attached__list__item--video').remove();
        $image_list.append($image_item);
        $image_list_container.removeClass('is-hidden');

        // prevent flash of bigger size
        $preview
            .prop('src', $me.data('video-thumbnail'))
            .data('upload-id', $me.data('video-id'));

        $image_list.removeClass('is-hidden');

        $('#postbox_video_id').val($me.data('video-id'));
        $("#postbox_video_id").attr("video-type", $me.data("video-type")),

        this.$textbox.focus();

        $('.postbox__video--selector').hide();

        return false;
    }

    click__image_upload(ev) {
        ev.preventDefault();
        if($(".postbox-attached__list__item--document").length > 0){
            alert("Document already selected for this Post. You can only add image or document or video into a post. ");
            return false;
        }
        if($(".postbox-attached__list__item--video").length > 0){
            alert("Video already selected for this Post. You can only add image or document or video into a post. ");
            return false;
        }
        $('#post-image-upload').click();
    }

    click__meta_item(ev) {
        this.$elem.removeClass('is-blurring');
    }

    click__postbox__post(ev) {
        this.$elem.find('.postbox__post.was-clicked').removeClass('was-clicked');
        $(ev.target).addClass('was-clicked');

        // Delay the form submit
        ev.preventDefault();

        _debounce(() => this.$elem.find('.postbox__form').submit(), 250)();
    }

    createPost(params) {
            // this.$elem.find("#create-post-pre-loader").removeClass("hidden");
            /* new code */
            // var postImagestags = this.$elem.find("#postImagesTags").val();
            // postImagestags = postImagestags.split(',');
            // this.$elem.find("#create-post-pre-loader").removeClass("hidden");
            // if (this.$elem.find("#fileUpload").val()) {
            //     if (this.$elem.find("[name='short_urls[]']").val()) {} else {
            //         if (this.$elem.find("#fileUpload")[0].files.length > 0) {
            //             postImagestags[0] = "";
            //             this.$elem.find("#postImagesTags").val(postImagestags.toString());
            //             this.$elem.find('#post-image-upload-form').submit();
            //             return false;
            //         }
            //         return false;
            //     }
            // }

            // if (this.$elem.find("#thumbnail img").attr("src") && this.$elem.find("#post-image-tags").length == 0) {
            //     // Cropped Image found
            //     if (this.$elem.find("#fileUpload").length > 0) {
            //         let jpegFile = this.$elem.find("#fileUpload")[0].files[0];
            //         let dataurl = this.$elem.find("#thumbnail img").attr("src");
            //         var arr = dataurl.split(','),
            //             mime = arr[0].match(/:(.*?);/)[1],
            //             bstr = atob(arr[1]),
            //             n = bstr.length,
            //             u8arr = new Uint8Array(n);
            //         while (n--) {
            //             u8arr[n] = bstr.charCodeAt(n);
            //         }
            //         let list = new DataTransfer();
            //         const newFile = new File([u8arr], "Cropped-" + jpegFile.name, { type: jpegFile.type });
            //         this.$elem.find("#fileUpload").parent().append("<input type='hidden' id='post-image-tags' name='tags' value='instagram'> ");
            //         list.items.add(newFile);
            //         this.$elem.find("#fileUpload")[0].files = list.files;
            //         postImagestags[1] = "instagram";
            //         this.$elem.find("#postImagesTags").val(postImagestags.toString());
            //         this.$elem.find('#post-image-upload-form').submit();
            //         return false;
            //     }
            // }



            // if (this.$elem.find("#fileUpload").val()) {
            //     if (this.$elem.find("[name='short_urls[]']").val()) {} else {
            //         if (this.$elem.find("#fileUpload")[0].files.length > 0) {
            //             let fileList = this.$elem.find("#fileUpload")[0].files;
            //             let jpegFile = this.$elem.find("#fileUpload")[0].files[0];
            //             /* New addition after push */
            //             let dataurl = this.$elem.find("#imageResize img").attr("src");
            //             if (this.$elem.find("#thumbnail img").attr("src")) {
            //                 dataurl = this.$elem.find("#thumbnail img").attr("src");
            //             }
            //             /* New addition after push Done */

            //             var arr = dataurl.split(','),
            //                 mime = arr[0].match(/:(.*?);/)[1],
            //                 bstr = atob(arr[1]),
            //                 n = bstr.length,
            //                 u8arr = new Uint8Array(n);
            //             while (n--) {
            //                 u8arr[n] = bstr.charCodeAt(n);
            //             }
            //             const newFile = new File([u8arr], jpegFile.name, { type: jpegFile.type });

            //             let list = new DataTransfer();
            //             list.items.add(newFile);
            //             this.$elem.find("#fileUpload")[0].files = list.files;

            //             this.$elem.find('#post-image-upload-form').submit();

            //             return false;
            //         }
            //         return false;
            //     }
            // }

            /* new code ended */
            let currentThis = this.$elem;
            let $me = this.$elem.find('form'),
                $preview = this.$elem.find('.postbox__preview'),
                request;
            /* Multiple Image upload functionality started from here */
                function uploadImage(img, currentInstance, type){
                    if(img){
                        let dataurl = img.attr("src");
                        var arr = dataurl.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]),
                            n = bstr.length,
                            u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        let list = new DataTransfer();
                        let newFile = "";

                        if(typeof type != 'undefined' && type == "instagram"){
                            newFile = new File([u8arr], "instagram-"+img.attr("data-name"), { type: img.attr("data-type") });
                        }else{
                            newFile = new File([u8arr], img.attr("data-name"), { type: img.attr("data-type") });
                        }
                        list.items.add(newFile);
                        var data = new FormData();
                        $("#post-image-upload-form").serializeArray().map(function(x){
                            data.append(x.name, x.value);
                        });
                        data.append('file', newFile);
                        $.ajax({
                            url: $("#post-image-upload-form").attr('action'),
                            method: 'post',
                            processData: false,
                            contentType: false,
                            cache: false,
                            data: data,
                            enctype: 'multipart/form-data',
                            success: function(t, i) { 
                                var n = $(t).find("Location").text();
                                if(n){
                                    img.attr("data-isUploaded","true");
                                    /* this one */
                                    if(currentInstance.find(".postbox__form").find("#postImagesTags").val()){
                                        var postImagestags = currentInstance.find(".postbox__form").find("#postImagesTags").val().split(",");
                                    }else{
                                        var postImagestags = [];
                                    }
                                    
                                    if(typeof type != 'undefined'){
                                        postImagestags.push(type);
                                    }else{
                                        postImagestags.push(" ");
                                    }
                                    currentInstance.find(".postbox__form").find("#postImagesTags").val(postImagestags.toString());
                                    /* end this */

                                    currentInstance.find(".postbox__form").append('<input type="hidden" data-index="'+(currentInstance.find(".AwsUplodedImage").length + 1) + '"  class="AwsUplodedImage" id="AwsUplodedImage" name="images[]" value="' + n + '">')
                                    setTimeout(() => {
                                        currentInstance.find(".postbox__form").submit();
                                    }, 100); 
                                    return false;
                                }
                            },
                            error: function (xhr, ajaxOptions, thrownError) {}
                        });
                    }
                }
                var isImageNotUpdated = false;

                
                currentThis.find("#create-post-pre-loader").removeClass("hidden");

                /* all images */
                if($("#normal-thumbnail-preview img").length > 0){
                    for(var i=0; i< $("#normal-thumbnail-preview img").length; i++){
                        if($("#normal-thumbnail-preview img").eq(i).attr("data-isUploaded") == "true"){

                        }else{
                            isImageNotUpdated = true;
                            const img = $("#normal-thumbnail-preview img").eq(i);
                            uploadImage(img, currentThis, " ");
                            break;
                            return false;
                        }
                    }
                    if(isImageNotUpdated){
                        return false;
                    }
                }
                
                /* ony instagram images */
                if($("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").length > 0){
                    
                    var croppedImageFound = false;
                    for(var i=0; i< $("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").length; i++){
                        if($("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").eq(i).attr("data-isCropped") == "false"){
                            $("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").eq(i).addClass("error-Image");
                            croppedImageFound = true; 
                        }
                    }
                    if(croppedImageFound){
                        currentThis.find("#create-post-pre-loader").addClass("hidden");
                        alert("Please Crop all Images for Instagram");
                        return false;
                    }
                    for(var i=0; i< $("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").length; i++){
                        if($("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").eq(i).attr("data-isUploaded") == "true"){

                        }else{
                            const img = $("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").eq(i);
                            uploadImage(img, currentThis, "instagram");
                            isImageNotUpdated = true;
                            break;
                            return false;
                        }
                    }
                    if(isImageNotUpdated){
                        return false;
                    }
                    
                    
                }
                

                if ($me.find(".postbox__post.was-clicked").val() == "1") {
                    if($me.find(".AwsUplodedImage").length == 0 && $("#iconInstagram:checked").length == 1 && $("#postbox_video_id").val()==""){
                        currentThis.find("#create-post-pre-loader").addClass("hidden");
                        alert("Please select image, For sharing on instagram.");
                        return false;
                    }
                }

                if(document.getElementById('iconInstagram') && document.getElementById('iconInstagram').length && document.getElementById('iconInstagram').checked){
                    if($("#instagram-thumbnail-preview .thumbnail-preview-container .thumbnail-preview-inner-section img").length == 0 && $("#postbox_video_id").val()==""){
                        alert("Please select image, For sharing on instagram.");
                        return false;
                    }
                }

                if(params.images.length == 0){
                    let images = [];
                    let imageIndex = [];
                    for(var i=0; i< $me.find(".AwsUplodedImage").length; i++){
                        imageIndex.push($me.find(".AwsUplodedImage").eq(i).attr("data-index"));
                        images.push($me.find(".AwsUplodedImage").eq(i).val());
                    }
                    params.images = images;
                    params.imageIndex = imageIndex;
                }
                if($("#postbox_video_id").val()){
                    if($("#iconInstagram") && $("#iconInstagram").length && $("#iconInstagram").prop('checked')){
                        var videoType = $("#postbox_video_id").attr("video-type");
                        if(videoType=="instagram-post"){

                        }else{
                            $("#create-post-pre-loader").hide();
                            if(confirm("You have selected a video which is not compitable with instagram, So it will not share on instagram.")){
                                $("#create-post-pre-loader").show();
                            }
                        }
                    }
                }
                
                var selectedNetwork = [];
                var share = {};
                if ($me.find(".share-on-network:checked").length) {
                    $me.find(".share-on-network:checked").each(function(ind, val) {
                        selectedNetwork.push(val.value);
                    })
                }
                if ($me.find(".form__field--post--share").length) {
                    $me.find(".form__field--post--share").each(function(ind, val) {
                        var imageId = "";
                        if($me.find(".post-image-ids").length > 0){
                            imageId = $me.find(".post-image-ids").eq(0).val();
                        }
                        var id = val.name;
                        var newVal = val.value;
                        share[id] = newVal;
                    })
                }

                params.shares = share;
                params.networks = selectedNetwork;
            /* Multiple Image upload functionality Ended here */

            // Send the post creation request
            request = $.ajax({
                headers: settings.api_headers,
                url: '/posts',
                data: params,
                type: 'POST',
                dataType: 'json',
            });

            // Add our request handlers to the promise
            request
                .fail((jqXHR, textStatus) => {
                    currentThis.find("#create-post-pre-loader").addClass("hidden");
                    sweetAlert({
                        title: 'Sorry!',
                        text: 'There was a problem creating your post',
                        type: 'error',
                    })
                })

            // Post was successfully created
            .done((data, textStatus, jqXHR) => {
                // if (null !== data.object.embargo) {
                //     this.resetForm();
                //     sweetalert({
                //         title: 'Post scheduled',
                //         text: 'Your post has been saved, and will activate at the time it was scheduled for.',
                //         type: 'success',
                //     });

                //     return;
                // }
                // Determine which column to put the new post into
                $(".AwsUplodedImage").remove();
                selectedImagesArray.splice(0, selectedImagesArray.length);
                instagramSelectedImageArray.splice(0, instagramSelectedImageArray.length);

                const leftColCount = $('.post-list--left .post').length;
                const rightColCount = $('.post-list--right .post').length;
                let col = leftColCount > rightColCount ? 'right' : 'left';

                let the_post = data.object;

                this.$elem.find('.postbox-attached__list__item').remove();

                // don't ask about this
                this.liveposts.ignorePost(the_post);

                // Find the stream
                var $posts = $('.posts__list'), // TODO: Unused?
                    // Build the new post                 // TODO: Unused?
                    $new_post = Post.renderPost(
                        the_post.id,
                        the_post,
                        this.postInstance,
                        true,
                        true,
                        true,
                        col
                    );

                $('.tooltip').tooltipsy({ offset: [0, -10] });

                // Did the user want to share the post as well?
                let share_me = $me.find('.postbox__post.was-clicked').val() == 1;

                // Okay. Did the user want to share the post?
                if (!!the_post.amped && share_me) {
                    var t = the_post.id;
                    var n,o = "/posts/" + t + "/shares";
                    var selectedNetwork = [];
                    var share = {};
                    if ($me.find(".share-on-network:checked").length) {
                        $me.find(".share-on-network:checked").each(function(ind, val) {
                            selectedNetwork.push(val.value);
                        })
                    }
                    if ($me.find(".form__field--post--share").length) {
                        $me.find(".form__field--post--share").each(function(ind, val) {
                            var imageId = "";
                            if($me.find(".post-image-ids").length > 0){
                                imageId = $me.find(".post-image-ids").eq(0).val();
                            }
                            var id = val.name;
                            var newVal = val.value;
                            share[id] = newVal;
                        })
                    }
                    setTimeout(() => {
                        var data = {
                            network: selectedNetwork,
                            share,
                            auto_schedule: (params.embargo == "") ? "0":"1",
                            on_create: 1,
                            emails: "",
                            "schedule[]": params.embargo,
                            geo_locations: params.geo_locations,
                            target_audiences: params.target_audiences,
                        };

                        request = $.ajax({
                            headers: settings.api_headers,
                            url: o,
                            data: data,
                            type: 'POST',
                        });

                        request.fail(() => {
                            sweetalert({
                                title: 'Sorry!',
                                text: 'There was a problem sharing your post',
                                type: 'error',
                            });
                        }).done((i, n, o) => { 
                            this.resetForm();
                            currentThis.find("#create-post-pre-loader").addClass("hidden");
                            currentThis.find("#imageResize").html("");
                            currentThis.find("#sectionResize").addClass("hidden");
                            // currentThis.find("#sectionDragAndDrop").removeClass("hidden");
                            currentThis.find("[name='short_urls[]']").remove();

                            currentThis.find("#sectionDragAndDrop-normal").removeClass("hidden");
                            currentThis.find("#normal-thumbnail-preview").addClass("hidden");
                            currentThis.find("#sectionDragAndDrop-instagram").addClass("hidden");
                            currentThis.find("#instagram-thumbnail-preview").addClass("hidden");
                            currentThis.find("#sectionResize").addClass("hidden");

                            $preview.hide();
                            var r;
                            (r = $me || "Schedule shares" == $(".sa-confirm-button-container button").text() ? "Your shares have been scheduled!" : "Your post has been shared successfully!");
                            $.toast({ 
                                heading: "Success", 
                                text: r, 
                                icon: "success", 
                                loader: !0, 
                                loaderBg: "#9EC600" 
                            });
                            swal.close();
                            var l = $("#post-" + t + ' .post__view-interactions[data-type="shares"] span');
                            var c = l.text();
                            // l.text(Number(c) + Number(s));
                            this.resetForm();
                            window.location.reload();
                            // var d = new k.a(),
                            // h = l.images;
                            // d.create(l.post, l.id, !0, h);

                            
                        });
                    }, 500);
                    
                    // let sharebox = new ShareBox(),
                    //     images = the_post.images;

                    // // Image Code created by Waseem
                    // var newimages = [];
                    // $.each(images, (i, val) => {
                    //     const image_height = val.height;
                    //     const image_width = val.width;
                    //     const image = {
                    //         socialType: e(a).data("social-type") ,
                    //         image_id: val.image_id,
                    //         image_height,
                    //         image_width,
                    //         image_url: val.image_url,
                    //         image_meets_size_restrictions: this.imageMeetSizeRestrictions(
                    //             image_height,
                    //             image_width
                    //         )
                    //     };
                    //     newimages.push(image);
                    // });
                    // sharebox.create(the_post.post, the_post.id, true, newimages);

                }else{
                    $preview.hide();
                    this.resetForm();
                    currentThis.find("#create-post-pre-loader").addClass("hidden");
                    currentThis.find("#imageResize").html("");
                    currentThis.find("#sectionResize").addClass("hidden");
                    // currentThis.find("#sectionDragAndDrop").removeClass("hidden");
                    currentThis.find("[name='short_urls[]']").remove()
                    window.location.reload();
                }
                // Reset the post box
              
                
            });
        }
        /**
         * Check to see if the image is a size that can be shared to social networks
         * @param {*} height
         * @param {*} width
         */
    imageMeetSizeRestrictions(height, width) {
        if (height >= 4096) {
            return false;
        }

        if (width >= 4096) {
            return false;
        }

        return true;
    }
    focus__textarea(ev) {
        this.$elem.addClass('is-active');
        this.$elem.find('.postbox__footer').slideDown('fast');
    }

    /**
     * Use me to get a list of valid urls from a string.
     * @param {*} text
     */
    getPostLinks(text) {
        // Ok so this is a PITA
        // New plan, grab the urls with a slightly more improved regex, make sure they're valid (and not emails) and cross your fingers.

        // Throw a large net, match anything close
        const first_pass_urls = text.match(
            /*new RegExp(
                /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z\.\-]{2,255}\b([\/?][-a-zA-Z0-9,@:%_\+.~#?&//=]*)?/gi
            )*/
            new RegExp(/@\[([^\]]+)\]|\b[-a-zA-Z0-9@:%_\+.~#?&//\[=]{2,256}\.[a-z\.\-]{2,255}\b([\/?][-a-zA-Z0-9,@:%_\+.~#?&//=]*)?/gi)
        );
        if (!first_pass_urls) {
            // No urls found
            return {};
        }

        const urls = [];
        for (let possibleUrl of first_pass_urls) {
            // Check if im an email and get rid of it
            const emailRegex = new RegExp(
                /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
            );
            if (emailRegex.test(possibleUrl)) {
                // It's an email, ignore it.
                continue;
            }

            let parsedUrl = url.parse(possibleUrl);

            if (!(
                    parsedUrl.protocol === 'http:' ||
                    parsedUrl.protocol === 'https:' ||
                    parsedUrl.protocol === null
                )) {
                // Bad protocol, ignore it
                continue;
            }

            let normalizedUrl = '';
            try {
                // Normalise the url but don't change it perminently as we need to perform a find and replace later
                normalizedUrl = normalizeUrl(possibleUrl, normalizeOptions);
            } catch (err) {
                // Failed to normalise, assume it's bad
                continue;
            }

            if (!validUrl.isWebUri(normalizedUrl)) {
                // Not a valid URI so sack it off
                continue;
            }

            // This is dirty but without modifying the regex above, this is the easiest way to do it
            if (possibleUrl.indexOf('..') !== -1) {
                // Found multiple dots in a row, sack it off
                continue;
            }

            urls.push(possibleUrl);
        }

        return urls;
    }

    async handleLinkShortening($elem) {
        if (this.isStillProcessing()) {
            // Still processing, don't try it again
            return;
        }

        // Match up any existing short links
        let $shortened = $elem.find('.postbox__short_link');
        let $post_box = $elem.find('.form__field--post');
        let post = $post_box.val();

        const post_links = this.getPostLinks(post);

        if (Object.keys(post_links).length === 0) {
            return;
        }

        // Tidy any that have been deleted
        if ($shortened.length) {
            $shortened.each(function(k, v) {
                let $me = $(v);

                if (post_links.indexOf($me.data('short_url')) == -1) {
                    $me.remove();
                }
            });
        }

        // Update the list of short links
        $shortened = $elem.find('.postbox__short_link');

        // If there are new ones, run the shorten & replace
        if (!!post_links && !!post_links.length) {
            $.each(post_links, (k, v) => {
                // Ensure that the link we have isn't a short link already
                let $found = $shortened.filter(function() {
                    return $(this).data('short_url') == v;
                });

                // If it's not, run the shorten
                if (!!!$found.length) {
                    if(v[0] != "@"){
                        let link = v;

                        // Normalize the url
                        link = normalizeUrl(link, normalizeOptions);

                        this.setProcessing(link, true); // Keep track of what's being processed

                        $.ajax({
                                headers: settings.api_headers,
                                type: 'POST',
                                url: '/urls',
                                data: {
                                    url: link,
                                },
                                dataType: 'json',
                            })
                            .done((data, textStatus, jqXHR) => {
                                let $new_link = $(
                                        '<input class="postbox__short_link" type="hidden" name="short_urls[]" value="' +
                                        data.id +
                                        '">'
                                    ),
                                    url = data.url,
                                    href = data._links.self.href,
                                    post = $post_box.val();

                                $new_link.data('url', url).data('short_url', href);

                                $elem.find('.postbox__form').append($new_link);
                                $post_box.val(post.replace(v, href));
                                this.setProcessing(data.url, false);
                                this.$textbox.blur().focus();
                            })
                            .fail((data) => {
                                this.setProcessing(link, false);
                            });
                    }
                }
            });
        }
        return;
    }

    resetForm() {
        var $postbox = this.$elem.find('#postbox__post'),
            $notes = this.$elem.find('.postbox__note input'),
            $img_preview = this.$elem.find('.postbox-attached__list'),
            $share_btn = this.$elem.find('.postbox__post-share'),
            $channels = this.$elem.find('.postbox__channels'),
            $tags = this.$elem.find('.postbox__tags__field'),
            $amp = this.$elem.find('.postbox__amp:checked'),
            $unamp = this.$elem.find('.postbox__amp[value="0"]'),
            $images = this.$elem.find('.postbox__images'),
            $post = this.$elem.find('.postbox__post'),
            $preview = this.$elem.find('.postbox__preview'),
            $short_links = this.$elem.find('.postbox__short_link');

            this.$elem.find("#sectionDragAndDrop-normal").removeClass("hidden");
            this.$elem.find("#normal-thumbnail-preview").addClass("hidden");
            this.$elem.find("#sectionDragAndDrop-instagram").addClass("hidden");
            this.$elem.find("#instagram-thumbnail-preview").addClass("hidden");
            this.$elem.find("#sectionResize").addClass("hidden");
            
        // Empty the post box
        $postbox.val('');

        // Hide the image previews
        $img_preview.addClass('is-hidden');

        // Hide the postbox modal
        window.modals['postbox-modal'].close();

        // Shrink the posting box
        // this.$elem.removeClass('is-active');

        // Hide the footer
        // this.$elem.find('.postbox__footer').slideUp('fast');

        // Enable the Post & Share box
        $share_btn.removeAttr('disabled');

        // Empty the notes box
        $notes.val('');

        // Empty the channel box
        if (!!$channels[0].selectize) {
            $channels[0].selectize.clear();
        }

        // Empty the tags box
        if (!!$tags[0].selectize) {
            $tags[0].selectize.clear();
        }

        // Reset the amp status
        $unamp.removeAttr('checked');
        $amp.prop('checked', 'checked');

        // Clear the image attachments
        $images.empty();

        // Reset the submit state
        $post.removeClass('was-clicked');

        this.set_defaults();

        $('.postbox__advanced').addClass('visually-hidden');

        // Clear and hide the link preview
        $preview
            .find('.article-preview__img')
            .attr('src', '')
            .end()
            .find('.article-preview__title')
            .text('')
            .end()
            .find('.article-preview__description')
            .text('')
            .end()
            .find('.article-preview__url')
            .text('')
            .end()
            .hide();

        // Remove the short URLs
        $short_links.remove();

        //
        this.previewCustomised = false; // is this used?

        // Reset the calculator count
        $.each(this.calculators, function(k, calculator) {
            calculator.resetCount();
        });
    }

    /**
     * Keep track of what's being processed
     * @param {*} key
     * @param {*} value
     */
    setProcessing(key, value) {
        switch (value) {
            case true:
                this.processing[key] = true;
                break;

            case false:
                delete this.processing[key];
                break;

            default:
                console.error('Invalid processing value set');
        }
    }

    async waitForReady() {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (!this.isStillProcessing()) {
                    clearInterval(interval);

                    return resolve();
                }
            }, 100);
        });
    }

    isStillProcessing() {
        return Object.keys(this.processing).length !== 0;
    }

    async sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }
        /**
         * Interrupt the main postbox submit to handle asynchronously
         *
         * @param  {Event} ev [description]
         * @return {void}    [description]
         */
    async submit__post(ev) {
        // Get the from
        let $me = $(ev.target);
        if ($me.hasClass('is-editing')) {
            let $preview = $me.find('.postbox__preview');

            if ($preview.length > 0 && $preview.is(':visible')) {
                // Only set title and description if they have changed
                $me.append(
                    '<input type="hidden" name="custom_url_data[url]" value="' +
                    $preview.find('.article-preview__url').text() +
                    '">'
                );

                var preview_title = $preview.find('.article-preview__title'),
                    preview_description = $preview.find('.article-preview__description'),
                    preview_image = $preview.find('.article-preview__img');

                if (preview_title.text() != preview_title.data('original-title')) {
                    $me.append(
                        '<input type="hidden" name="custom_url_data[title]" value="' +
                        preview_title.text() +
                        '">'
                    );
                }

                if (
                    preview_description.text() !=
                    preview_description.data('original-description')
                ) {
                    $me.append(
                        '<input type="hidden" name="custom_url_data[description]" value="' +
                        preview_description.text() +
                        '">'
                    );
                }

                if (preview_image.attr('src') != preview_image.data('original-image')) {
                    $me.append(
                        '<input type="hidden" name="custom_url_data[image]" value="' +
                        preview_image.attr('src') +
                        '">'
                    );
                }
            }
            

            return true;
        }

        // Stop the submission
        ev.preventDefault();

        // Fixes SA-1
        // Wait until all the short urls have been processed before we submit the form
        await this.waitForReady();

        // Find the posting box
        let geolocationArray = [];
        $me.find("select.postbox__geo_locations").each(function(ind, val){
            if($(this).val().length > 0){
                fieldValue=$(this).val();
                if(fieldValue){
                    geolocationArray[$(this).attr("data-account_id").toString()]= fieldValue;
                }
            }
        });
        geolocationArray=Object.fromEntries(Object.entries(geolocationArray).filter(([key, value]) => value.length > 0));
        // Find the posting box
        let targetAudiencesArray ={industries: [], seniorities: [], functions: [], company_size: []};
        var fieldValue="";
        $me.find("select.postbox__targeted_industries").each(function(ind, val){
            if($(this).val().length > 0){
                fieldValue=$(this).val();
                if(fieldValue){
                    targetAudiencesArray.industries[$(this).attr("data-account_id").toString()]=fieldValue;
                }
            }
        });
        targetAudiencesArray.industries=Object.fromEntries(Object.entries(targetAudiencesArray.industries).filter(([key, value]) => value.length > 0));
        // Find the posting box
        $me.find("select.postbox__targeted_seniorities").each(function(ind, val){
            if($(this).val().length > 0){
                fieldValue=$(this).val();
                if(fieldValue){
                    targetAudiencesArray.seniorities[$(this).attr("data-account_id").toString()]=fieldValue;
                }
            }
        });
        targetAudiencesArray.seniorities=Object.fromEntries(Object.entries(targetAudiencesArray.seniorities).filter(([key, value]) => value.length > 0));
        // Find the posting box
        $me.find("select.postbox__targeted_functions").each(function(ind, val){
            if($(this).val().length > 0){
                fieldValue=$(this).val();
                if(fieldValue){
                    targetAudiencesArray.functions[$(this).attr("data-account_id").toString()]=fieldValue;
                }
            }
        });
        targetAudiencesArray.functions=Object.fromEntries(Object.entries(targetAudiencesArray.functions).filter(([key, value]) => value.length > 0));
        // Find the posting box
        $me.find("select.postbox__targeted_company_size").each(function(ind, val){
            if($(this).val().length > 0){
                fieldValue=$(this).val();
                if(fieldValue){
                    targetAudiencesArray.company_size[$(this).attr("data-account_id").toString()]=fieldValue;
                }
            }
        });
        targetAudiencesArray.company_size=Object.fromEntries(Object.entries(targetAudiencesArray.company_size).filter(([key, value]) => value.length > 0));
        let $textarea = $me.find('#postbox__post'),
            // Find the channel box
            $channels = $me.find('.postbox__channels'),
            // Find the amp switch state
            $amped = $me.find('.postbox__amp:checked'),
            // Find the button that was pressed
            $submit = $me.find('.postbox__post.was-clicked'),
            // Find the preview
            $preview = $me.find('.postbox__preview'),
            /*$geo_locations = $me.find('.postbox__geo_locations'),*/
            
            // Build the API request payload
            params = {
                post: $textarea.val(),
                channels: $channels.val() || [],
                amp: $amped.val(),
                images: [],
                postImagesTags: $("#postImagesTags").val(),
                shares:[],
                on_post_create:1,
                networks:[],
                video_id: $('#postbox_video_id').val(),
                document_id: $('#postbox_documents_id').val(),
                customise_shares: $submit.val(),
                tags: $me.find('.postbox__tags__field').val(),
                notes: $me.find('.postbox__note input').val(),
                embargo: $me.find('.embargo-timestamp').val(),
                sharetill: $me.find(".embargo-share-till-timestamp").val(),
                short_urls: [],
                custom_url_data: {
                    url: null,
                    title: null,
                    description: null,
                    image: null,
                },
                geo_locations: geolocationArray,
                target_audiences: targetAudiencesArray
            };

        $me.find('.postbox__short_link').each(function(k, v) {
            params.short_urls.push($(v).val());
        });

        $me.find('.postbox-attached__image').each(function(k, v) {
            params.images.push($(v).prop('src'));
        });

        // If preview is visible, grab the title and description
        if ($preview.length > 0 && $preview.is(':visible')) {
            // Only set title and description if they have changed
            params.custom_url_data['url'] = $preview
                .find('.article-preview__url')
                .text();

            var preview_title = $preview.find('.article-preview__title'),
                preview_description = $preview.find('.article-preview__description'),
                preview_image = $preview.find('.article-preview__img');

            if (preview_title.text() != preview_title.data('original-title')) {
                params.custom_url_data['title'] = preview_title.text();
            }

            if (
                preview_description.text() !=
                preview_description.data('original-description')
            ) {
                params.custom_url_data['description'] = preview_description.text();
            }

            if (preview_image.attr('src') != preview_image.data('original-image')) {
                params.custom_url_data['image'] = preview_image.attr('src');
            }
        }

        params.channels =
            typeof params.channels == 'object' ? params.channels : [params.channels];

        // Check if there was some post content
        if (!!!params.post.length && !!!params.images.length) {
            sweetalert({
                title: 'Posting Error',
                text: 'Sorry, you must enter some text and attach an image before you can create a post.',
                type: 'error',
            });
        } else {
            this.createPost(params);
        }

        // For prettiness, remove the active state from the button
        $me.find('.btn').blur();
    }

    submit__post_image_upload(ev) {
        let $me = $(ev.target),
            elem = this.$elem,
            $textbox = this.$textbox,
            $image_list = elem.find('.postbox-attached__list'),
            $image_list_container = elem.find('.postbox-attached'),
            // This will become the preview'd image
            $image_item = $(
                nunjucksEnv.render('html/ui/image-item.html', {
                    url: '/img/ajax/spinner.gif',
                    id: 0,
                })
            ),
            $preview = $image_item.find('.postbox-attached__image');

        $image_list.append($image_item);
        $image_list_container.removeClass('is-hidden');
        // this.setProcessing('post_image', true);
        let self = this;
        this.allowPosting(false);

        var options = {
            url: $me.attr('action'),
            error: function(response, status) {
                // self.setProcessing('post_image', false);
                self.allowPosting(true);

                if (typeof response.responseText !== 'undefined') {
                    $image_item.hide();
                    $image_list.children().last().remove();
                    let xmlDoc = $.parseXML(response.responseText);
                    let $xml = $(xmlDoc),
                        $code = $xml.find('Code');
                    if ($code.text() == 'EntityTooLarge') {
                        // Specific AWS complaint for image size
                        sweetalert({
                            title: 'Upload Error',
                            text: 'Sorry, that image is too large. Images must be less than 400MB. Please try a different image.',
                            type: 'error',
                        });
                    } else {
                        // Other AWS complaint
                        sweetalert({
                            title: 'Upload Error',
                            text: 'There was a problem uploading the image: '.$xml
                                .find('Message')
                                .text(),
                            type: 'error',
                        });
                        console.error('AWS Error', $code.text());
                    }
                } else {
                    // Catch call
                    sweetalert({
                        title: 'Upload Error',
                        text: 'There was a problem uploading the image. Please try again, or use a different image. Images must be less than 400MB.',
                        type: 'error',
                    });
                }
            },
            success: function(response, status) {
                // self.setProcessing('post_image', false);
                self.allowPosting(true);
                var image = $(response).find('Location').text();
                elem.find("input[name='image']").val(image);

                $.ajax({
                    url: '/urls',
                    type: 'post',
                    data: {
                        url: image,
                        is_image: 1,
                    },
                    headers: {
                        Accept: 'application/json',
                    },
                }).done(function(result) {
                    if (typeof result._links.self.href !== 'undefined') {
                        elem
                            .find('.postbox__form')
                            .append(
                                '<input type="hidden" name="short_urls[]" value="' +
                                result.id +
                                '">'
                            );
                    }

                    // Why are we doing this twice?! ¯\_(ツ)_/¯
                    $.ajax({
                        url: '/urls',
                        type: 'post',
                        data: { url: image, is_image: 1 },
                        headers: { Accept: 'application/json' },
                    }).done(function(data) {
                        var result = data;

                        if (typeof result._links.self.href !== 'undefined') {
                            if($("#share-image-id").length > 0){
                                // july 11th code
                                $.ajax({ 
                                    url: "/posts/"+$("#instagram-share-crop-post-id").val()+"", 
                                    type: "post", 
                                    data: { images: [ result.url ], postImagesTags: "instagram" }, 
                                    headers: { Accept: "application/json" } 
                                }).done(function(data) {
                                    $(".share-form").append("<input type='hidden' name='images["+$("#share-image-id").val()+"][]' value='"+data.images[data.images.length - 1].image_id+"'/>");
                                    $(".share-now").click();
                                });
                                //
                            }else{
                                elem
                                    .find('.postbox__form')
                                    .append(
                                        '<input type="hidden" name="short_urls[]" value="' +
                                        result.id +
                                        '">'
                                    );

                                if (result._links.self.href != '') {
                                    // Didn't need this conditional, but the extra space was a pain
                                    $('#postbox__post').val(
                                        $('#postbox__post').val() +
                                        ' ' +
                                        result._links.self.href +
                                        ' '
                                    );

                                }

                                var $attached = elem.find('.postbox-attached'),
                                    $image_list = $attached.find('.postbox-attached__list'),
                                    $images = elem.find('.postbox__images');

                                // prevent flash of bigger size
                                $preview.prop('src', result.url).data('upload-id', result.id);

                                $image_list.removeClass('is-hidden');

                                $images.append(
                                    '<input type="hidden" name="images[]" value="' + image + '">'
                                );

                                $textbox.focus();

                                elem.find(".postbox__form").submit();
                            }
                        }
                    });
                });
            },
        };

        $me.ajaxSubmit(options);

        return false;
    }

    submit__post_image_upload_old(ev) {
        let $me = $(ev.target),
            elem = this.$elem,
            $textbox = this.$textbox,
            $image_list = elem.find('.postbox-attached__list'),
            $image_list_container = elem.find('.postbox-attached'),
            // This will become the preview'd image
            $image_item = $(
                nunjucksEnv.render('html/ui/image-item.html', {
                    url: '/img/ajax/spinner.gif',
                    id: 0,
                })
            ),
            $preview = $image_item.find('.postbox-attached__image');

        $image_list.append($image_item);
        $image_list_container.removeClass('is-hidden');
        // this.setProcessing('post_image', true);
        let self = this;
        this.allowPosting(false);

        var options = {
            url: $me.attr('action'),
            error: function(response, status) {
                // self.setProcessing('post_image', false);
                self.allowPosting(true);

                if (typeof response.responseText !== 'undefined') {
                    $image_item.hide();
                    $image_list.children().last().remove();
                    let xmlDoc = $.parseXML(response.responseText);
                    let $xml = $(xmlDoc),
                        $code = $xml.find('Code');
                    if ($code.text() == 'EntityTooLarge') {
                        // Specific AWS complaint for image size
                        sweetalert({
                            title: 'Upload Error',
                            text: 'Sorry, that image is too large. Images must be less than 400MB. Please try a different image.',
                            type: 'error',
                        });
                    } else {
                        // Other AWS complaint
                        sweetalert({
                            title: 'Upload Error',
                            text: 'There was a problem uploading the image: '.$xml
                                .find('Message')
                                .text(),
                            type: 'error',
                        });
                        console.error('AWS Error', $code.text());
                    }
                } else {
                    // Catch call
                    sweetalert({
                        title: 'Upload Error',
                        text: 'There was a problem uploading the image. Please try again, or use a different image. Images must be less than 400MB.',
                        type: 'error',
                    });
                }
            },
            success: function(response, status) {
                // self.setProcessing('post_image', false);
                self.allowPosting(true);
                var image = $(response).find('Location').text();
                elem.find("input[name='image']").val(image);

                $.ajax({
                    url: '/urls',
                    type: 'post',
                    data: {
                        url: image,
                        is_image: 1,
                    },
                    headers: {
                        Accept: 'application/json',
                    },
                }).done(function(result) {
                    if (typeof result._links.self.href !== 'undefined') {
                        elem
                            .find('.postbox__form')
                            .append(
                                '<input type="hidden" name="short_urls[]" value="' +
                                result.id +
                                '">'
                            );
                    }

                    // Why are we doing this twice?! ¯\_(ツ)_/¯
                    $.ajax({
                        url: '/urls',
                        type: 'post',
                        data: { url: image, is_image: 1 },
                        headers: { Accept: 'application/json' },
                    }).done(function(data) {
                        var result = data;

                        if (typeof result._links.self.href !== 'undefined') {
                            elem
                                .find('.postbox__form')
                                .append(
                                    '<input type="hidden" name="short_urls[]" value="' +
                                    result.id +
                                    '">'
                                );

                            if (result._links.self.href != '') {
                                // Didn't need this conditional, but the extra space was a pain
                                $('#postbox__post').val(
                                    $('#postbox__post').val() +
                                    ' ' +
                                    result._links.self.href +
                                    ' '
                                );
                            }

                            var $attached = elem.find('.postbox-attached'),
                                $image_list = $attached.find('.postbox-attached__list'),
                                $images = elem.find('.postbox__images');

                            // prevent flash of bigger size
                            $preview.prop('src', result.url).data('upload-id', result.id);

                            $image_list.removeClass('is-hidden');

                            $images.append(
                                '<input type="hidden" name="images[]" value="' + image + '">'
                            );

                            $textbox.focus();
                        }
                    });
                });
            },
        };

        $me.ajaxSubmit(options);

        return false;
    }

    submit__preview_image_upload(ev) {
        let $me = $(ev.target),
            elem = this.$elem,
            $preview = this.$elem.find('.article-preview'),
            $image = $preview.find('.article-preview__img'),
            $spinner = $preview.find('.icon-loading');

        $spinner.show();
        $image.css({ opacity: 0.3 });

        let self = this;
        this.allowPosting(false);

        var options = {
            url: $me.attr('action'),
            error: function(response, status) {
                if (typeof response.responseText !== 'undefined') {
                    $spinner.hide();
                    let xmlDoc = $.parseXML(response.responseText);
                    let $xml = $(xmlDoc),
                        $code = $xml.find('Code');
                    if ($code.text() == 'EntityTooLarge') {
                        // Specific AWS complaint for image size
                        sweetalert({
                            title: 'Upload Error',
                            text: 'Sorry, that image is too large. Images must be less than 400MB. Please try a different image.',
                            type: 'error',
                        });
                    } else {
                        // Other AWS complaint
                        sweetalert({
                            title: 'Upload Error',
                            text: 'There was a problem uploading the image: '.$xml
                                .find('Message')
                                .text(),
                            type: 'error',
                        });
                    }
                } else {
                    // Catch call
                    sweetalert({
                        title: 'Upload Error',
                        text: 'There was a problem uploading the image. Please try again, or use a different image. Images must be less than 400MB.',
                        type: 'error',
                    });
                }

                self.allowPosting(true);
            },
            success: function(response, status) {
                var image = $(response).find('Location').text();

                // Replace the image!
                $image.attr('src', image);

                $spinner.hide();
                $image.css({ opacity: 1 });
                self.allowPosting(true);

                this.previewHasBeenModified = true;
                $('#article-preview-message').removeClass('visually-hidden').show();
                $('#article-preview-clear-button')
                    .removeClass('visually-hidden')
                    .show();
            },
        };

        $me.ajaxSubmit(options);

        return false;
    }

    // Essentially keep 'previewHasBeenModified' up to date with the modified status
    keyup__preview() {
        let $preview = this.$elem.find('.article-preview'),
            title = $preview.find('.article-preview__title'),
            description = $preview.find('.article-preview__description'),
            currentTitle = title.text(),
            originalTitle = title.data('original-title'),
            currentDescription = description.text(),
            originalDescription = description.data('original-description');

        if (
            currentTitle == originalTitle &&
            currentDescription == originalDescription
        ) {
            this.previewHasBeenModified = false;
            $('#article-preview-message').hide();
            $('#article-preview-clear-button').hide();
        } else {
            this.previewHasBeenModified = true;
            $('#article-preview-message').removeClass('visually-hidden').show();
            $('#article-preview-clear-button').removeClass('visually-hidden').show();
        }
    }

    // When you click on the undo link in the preview
    click__undo_preview() {
        let $preview = this.$elem.find('.article-preview'),
            title = $preview.find('.article-preview__title'),
            description = $preview.find('.article-preview__description'),
            image = $preview.find('.article-preview__img'),
            currentTitle = title.text(),
            originalTitle = title.data('original-title'),
            currentDescription = description.text(),
            originalDescription = description.data('original-description'),
            currentImage = image.attr('src'),
            originalImage = image.data('original-image');

        title.text(originalTitle);
        description.text(originalDescription);
        image.attr('src', originalImage);

        this.previewHasBeenModified = false;
        $('#article-preview-message').hide();
        $('#article-preview-clear-button').hide();

        return false;
    }

    change__embargo_time(ev) {
        if ($('.embargo-timestamp').val() !== 'undefined') {
            let $me = $(ev.currentTarget),
                strDate = $(ev.currentTarget).parent().parent().find('.embargo-date-select').val(),
                intHour = Number($(ev.currentTarget).parent().parent().find('.embargo-time-select--hour').val()),
                intMinute = Number($(ev.currentTarget).parent().parent().find('.embargo-time-select--minute').val()),
                bIsPM = $(ev.currentTarget).parent().parent().find('.embargo-time-select--ampm').val(),
                twentyFourHour = (bIsPM == "PM") ?
                intHour == 12 ?
                12 :
                12 + intHour :
                intHour == 12 ?
                0 :
                intHour,
                embargo_time = '';
            if (strDate != '') {
                embargo_time =
                    moment(strDate, 'ddd MMM DD YYYY').format('YYYY-MM-DD') +
                    ' ' +
                    this.zeroPad(twentyFourHour) +
                    ':' +
                    this.zeroPad(intMinute) +
                    ':00';
                let dateObj = moment(embargo_time).toDate();

                if (dateObj.getTime() > new Date().getTime()) {
                    if (false === bIsPM) {
                        // lets try changing the AM to PM and see if that sorts it!
                        let new_embargo_time = moment(embargo_time)
                            .add(12, 'hour')
                            .format('YYYY-MM-DD HH:mm:ss'),
                            newDateObj = moment(new_embargo_time).toDate();

                        if (newDateObj.getTime() <= new Date().getTime()) {
                            dateObj = newDateObj;
                            embargo_time = new_embargo_time;

                            let $ampm = $(ev.currentTarget).parent().parent().find('.embargo-time-select--ampm');
                            $ampm.val('PM');
                        }
                    }
                }
            }
            if($(ev.currentTarget).attr("data-timestamp")){
                $("."+$(ev.currentTarget).attr("data-timestamp")).val(embargo_time)
            }else{
                $(ev.currentTarget).parent().parent().find(".embargo-timestamp").val(embargo_time)
            }

            // $('.embargo-timestamp').val(embargo_time);

            if ('' == embargo_time) {
                this.$elem.find('.postbox__post').removeAttr('disabled');
                
            } else {
                if(Date.now() < new Date(embargo_time).getTime()){
                    this.$elem.find('.postbox__post').removeAttr('disabled');
                }else{
                    this.$elem.find('.postbox__post').attr('disabled', 'disabled');
                }
            }
        } else {
            this.$elem.find('.postbox__post').removeAttr('disabled');
        }
    }

    /**
     * Will toggle the ability to post (&share) from a UI point of view
     * @param {*} allow
     */
    allowPosting(allow = true) {
        if (allow === true) {
            this.$elem.find('.postbox__post').removeAttr('disabled');
            this.$elem.find('.postbox__post-share').removeAttr('disabled');
        } else {
            this.$elem.find('.postbox__post').attr('disabled', 'disabled');
            this.$elem.find('.postbox__post-share').attr('disabled', 'disabled');
        }
    }

    zeroPad(number) {
        return 10 > number ? '0' + number : number;
    }

    set_defaults() {
        let date = this.get_date_to_next_n_minutes(15),
            momDate = moment(date),
            $date = $('.embargo-date-select'),
            $hour = $('.embargo-time-select--hour'),
            $minute = $('.embargo-time-select--minute'),
            $ampm = $('.embargo-time-select--ampm');

        $date.val('');
        $hour.val(momDate.format('h')); // 1-12
        $minute.val(momDate.format('mm')); // 00-59
        $ampm.val(momDate.format('A')); // AM/PM

        $('.embargo-timestamp').val('');

        if($(".embargo-share-till-timestamp").val()){
            var shareTillDate = moment($(".embargo-share-till-timestamp").val());
            $(".share-till-section .embargo-date-select").val(shareTillDate.format('ddd MMM DD YYYY'));
            $(".share-till-section .embargo-time-select--hour").val(shareTillDate.format('h'));
            $(".share-till-section .embargo-time-select--minute").val(shareTillDate.format('mm'));
            $(".share-till-section .embargo-time-select--ampm").val(shareTillDate.format('a').toUpperCase());
        }
    }

    // Used for the post scheduling
    get_date_to_next_n_minutes(numMinutes) {
        let date = new Date();
        date.setMinutes(numMinutes * Math.ceil(date.getMinutes() / numMinutes));

        if (date.getTime() < new Date().getTime()) {
            date.setMinutes(date.getMinutes() + numMinutes);
        }

        return date;
    }
}